export default "__VITE_ASSET__Bre$VLB5__"